export default __webpack_public_path__ + "static/media/rightTriangle.baf2533b.svg";